export const init = () => {
    if (document.querySelector('.js-footer-newsletter') && window.innerWidth >= 1056) {
        document.addEventListener('DOMContentLoaded', () => {
            const footer = document.querySelector('.footer');
            const anchor = footer.querySelectorAll('.content--right__item');
            const newsletter = footer.querySelector('.js-footer-newsletter');
            if (anchor[anchor.length - 1].offsetTop != newsletter.offsetTop) 
                newsletter.style.marginTop = `${anchor[anchor.length - 1].offsetTop - newsletter.offsetTop}px`;
        });
    }
};